import { AppConfigUtil } from "../utils/app-config.util";
export class ResourceUtil {
	public static getPropertyResourceUrl(): string {
		return (window as any).propertyResourceUrl;
	}
	public static getStaticResourceUrl(): string {
		return (window as any).staticResourceUrl;
	}
	public static getExternalResourcesUrl(): string {
		return (window as any).externalResourcesUrl;
	}
}
